import React from 'react';
import LogoEMD from '../images/logo-emd.png';
import LogoIoweb from '../images/logo-ioweb-hd.png';
import {Field, Form} from 'components/commons/Forms';
import {connect} from 'react-redux';
import {login, logout} from '../redux/user/actions';
import {changeSkiresort} from '../redux/global/actions';
import {deleteSkiresort} from '../redux/skiresorts/actions';
import {Status, Countries} from '../redux/_commons/const';
import {Part} from 'components/commons/Panes';

import ReactSpinner from 'react-spinjs';

import '../styles/login.less';
import '../styles/app.less';
import * as moment from 'moment';



//FIXME DRY

let StationsList = ({onSelect, skiresorts, deleteMode}) => {
  const lst = Countries.map(countryName => {
    const resorts = skiresorts.filter(sr => sr.country === countryName);
    if (resorts.length === 0) {
      return null;
    }
    return <Part title={ countryName } key={countryName}>
      { resorts.map(sr => <SkiresortItem skiresort={sr}
                    key={sr.id}
                    deleteMode={deleteMode}
               onSelect={onSelect}/>) }
      </Part>;
  });

  return (
      <div className="stations">
      {lst}
      </div>
  );
};

/** Element de la liste des stations */
let SkiresortItem = ({skiresort, onSelect, deleteMode}) => {
  let classes = ['skiresort'];
  let date = new Date().setHours(0, 0, 0, 0);
  let opened = new Date(skiresort.openingDate) <= date && date <= new Date(skiresort.closingDate);
  if (deleteMode) {
    classes.push('delete-mode');
  }
  console.log(moment.now());

  if (+moment.utc(skiresort.openingDate, 'YYYY-MM-DD HH:mm:SS') <= moment.now() && +moment.utc(skiresort.closingDate, 'YYYY-MM-DD HH:mm:SS') >= moment.now()) {
    classes.push('opened-resort');
  }
  return (
    <div className={classes.join(' ')} onClick={() => onSelect(skiresort)}>
      <div className={['status-badge', opened ? 'opened' : 'closed'].join(' ')} data-toggle="tooltip" title=
        {opened ? 'Station ouverte' : 'Station fermée'}></div>
      <span>{skiresort.name}</span>
    </div>
  );
};


/** Ecran de login (complet ) */
@connect(
  state => ({user: state.user}),
  {login, logout, changeSkiresort, deleteSkiresort}
)
export default class LoginScreen extends React.Component {

  constructor() {
    super();
    this.state = {
      deleteMode: false
    };
  }

  onSubmit(e) {
    e.preventDefault();
    let {login} = this.props;
    login(this.usernameInput.theValue());
    return false;
  }

  componentDidMount() {
    this.usernameInput.focus();
  }

  render() {
    let {user, logout, changeSkiresort, onPaneSelected, deleteSkiresort} = this.props;
    let content = null;
    if (user.status === Status.LOADING) {
      content = <ReactSpinner />;
    } else if (user.status === Status.OK && user.infos !== null) {
      let infos = user.infos;
      let onSelect;
      if (this.state.deleteMode) {
        onSelect = ({id, name}) => {
          if (confirm(`Êtes-vous sûr de vouloir supprimer la station ${name}, ses dameuses et les messages correspondants ?`)) {
            deleteSkiresort(id);
            this.setState({deleteMode: false});
          }
        };
      } else {
        onSelect = changeSkiresort;
      }
      content = (
        <div>
          <h2>Bienvenue !</h2>
          <div className="stations">
            {infos.ski_resorts.length === 0 ? <div>Aucune station disponible</div> :
              <StationsList skiresorts={user.infos.ski_resorts}
                              onSelect={onSelect}
                            deleteMode={this.state.deleteMode}/>}
            <div style={{clear: 'both'}}/>
          </div>
          {!infos.is_admin || this.state.deleteMode ? null :
            <div>
                <div onClick={() => this.setState({deleteMode: true})} className="action delete-mode">Supprimer une station</div>
                <div onClick={() => onPaneSelected('addskiresort')} className="action">Ajouter une station</div>
                <div onClick={() => onPaneSelected('editdates')} className="action">Modifier les dates d'ouverture de toutes les stations</div>
            </div>
          }
          {!this.state.deleteMode ? <div onClick={logout} className="action">Me déconnecter</div> :
            <div>
                <div onClick={() => this.setState({deleteMode: false})} className="action delete-mode">Annuler la suppression</div>
            </div>
          }

        </div>
      );
    } else {
      content = (
        <div>
          <Field ofType="text" label="Code d'accès"
                 style={{height: 40, fontSize: 22, textAlign: 'center'}}
                 ref={ ref => this.usernameInput = ref }/>
          <input type="submit" value="Se connecter" className="login-button"/>
        </div>
      );
    }

    return (
      <div className="login-page">
        <Header/>
        <Form onSubmit={(e) => this.onSubmit(e)}>
          {content}
        </Form>
        <Footer/>
      </div>
    );
  }

}


let Header = () => {
  return (
    <header>
      <h1>
        <img src={LogoEMD}/>
      </h1>
      <div className="motto">
        Suivi d'exploitation ATI Chauffeur Dameuse
      </div>
    </header>
  );
};

let Footer = () => {
  return (
    <div className="footer">
      <img src={LogoIoweb}/>
      <span>Conception et réalisation</span>

    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Login.js